/**
 * anime.js v4 setup. Import animation helpers from here so the house
 * easings/durations are applied consistently. anime.js is the second premium
 * engine (alongside GSAP): reach for it for fine-grained property/keyframe
 * choreography, SVG line/morph work, per-character text staggers and WAAPI.
 *
 * Engine choice guide:
 *   - GSAP        → scroll-driven timelines, pinning, Flip layout, complex SVG.
 *   - anime.js    → declarative keyframe stagger grids, text splitting, springs.
 *   - Framer/motion → React-state-driven micro-interactions (presence, layout).
 */
import { animate, createTimeline, createScope, stagger, svg, text, utils } from 'animejs';

import { DURATION, EASE } from './motion-tokens';

/** anime.js easing strings mirroring the house cubic-bezier curves. */
export const ANIME_EASE = {
  out: `cubicBezier(${EASE.out.join(', ')})`,
  inOut: `cubicBezier(${EASE.inOut.join(', ')})`,
  in: `cubicBezier(${EASE.in.join(', ')})`,
  spring: `cubicBezier(${EASE.spring.join(', ')})`,
} as const;

/** anime.js uses milliseconds — the house durations converted for convenience. */
export const ANIME_MS = {
  micro: DURATION.micro * 1000,
  fast: DURATION.fast * 1000,
  base: DURATION.base * 1000,
  slow: DURATION.slow * 1000,
  cinematic: DURATION.cinematic * 1000,
} as const;

export { animate, createTimeline, createScope, stagger, svg, text, utils };
